export default __webpack_public_path__ + "static/media/HomeAddressIcon.d07563e1.svg";